export default __webpack_public_path__ + "static/media/home-travel-agency-blog-03.e985772a.jpg";